import { useAtomValue } from "jotai";

import Button from "components/Button";
import Flex from "components/Flex";
import PageLayout from "components/PageLayout";
import Text from "components/Text";

import { useClientTranslation } from "hooks/useClientTranslation";
import { usePageRouting } from "hooks/usePageRouting";

import { IbanQuestion } from "./IbanQuestion";
import { useAcceptanceForm } from "./hooks/useAcceptanceForm";
import { getUserLocale } from "utils/locale/userLocale";
import { clientConfigAtom } from "atoms/clientConfig";

export const PayeeQuestions = () => {
  const { onTrackAndNext, currentProgressStep, continueCTA } = usePageRouting();
  const { t } = useClientTranslation();
  const {
    locale,
    speedyPayment,
  } = useAtomValue(clientConfigAtom);

  const { handleSubmit, isValid } = useAcceptanceForm(getUserLocale(locale));


  return (
    <PageLayout
      as="form"
      onSubmit={handleSubmit(onTrackAndNext({ name: "Personal Iban", properties: {} }))}
      currentStep={currentProgressStep}
      title={t("speedy_payment.payment_details.header")}
      dataTestId="speedyPaymentAcceptance"
      bottomButtons={
        <Button disabled={!isValid} fullWidth type="submit">
          {continueCTA}
        </Button>
      }
    >
      <Flex py={16} px={24} gap={16}>
        <Flex gap={48}>
          <Text sizeVariant="md" mb={32} mt={8}>
            {t("speedy_payment.payment_details.iban_required")}
          </Text>
          {speedyPayment?.questions?.map((variant) => (
            <IbanQuestion key={variant} variant={variant} />
          ))}
        </Flex>
      </Flex>
    </PageLayout>
  );
};
